module.exports = __webpack_public_path__ + "static/media/idiomas.fdec3d6f.png";